export default __webpack_public_path__ + "static/media/tailwind_atis.c289b98b.png";